/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2025) Takeda. All Rights Reserved
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

import { PRESCRIBING_INFORMATION_PAGE } from '../../navigation/navigation.constants';
import { VdzHeaderLink } from './header-link.component';

type Props = {
  extraClassNames?: string;
  index?: number;
  isExternal?: boolean;
};

export const VdzPrescribingInformationLink = ({
  extraClassNames,
  index,
  isExternal,
}: Props) => {
  const { t } = useTranslation();

  const indexSuffix = index !== undefined ? index + 1 : '';
  const href = t(`${keyPrefix}.href${indexSuffix}`);
  const title = t(`${keyPrefix}.title${indexSuffix}`);

  return (
    <VdzHeaderLink
      extraClassNames={extraClassNames}
      href={isExternal ? href : PRESCRIBING_INFORMATION_PAGE}
      isExternal={isExternal}
      title={title}
    />
  );
};

const keyPrefix = 'footer.vdz_indication_and_pi';
